//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.7.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import { DateTime, Duration } from "luxon";

export const DA_API_BASE_URL = new InjectionToken<string>('DA_API_BASE_URL');

@Injectable()
export class DataAnalyticsAdminSettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(DA_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getAll(): Observable<DataAnalyticsAdminSettingsDto> {
        let url_ = this.baseUrl + "/api/services/data-analytics/DataAnalyticsAdminSettings/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DataAnalyticsAdminSettingsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DataAnalyticsAdminSettingsDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DataAnalyticsAdminSettingsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DataAnalyticsAdminSettingsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveAll(body: DataAnalyticsAdminSettingsInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/data-analytics/DataAnalyticsAdminSettings/SaveAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSaveAll(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DataAnalyticsTaxOfficeProfilesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(DA_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param filter (optional) 
     * @param taxOfficeNamesFilter (optional) 
     * @param countryFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getOverview(filter: string | undefined, taxOfficeNamesFilter: string[] | undefined, countryFilter: string[] | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfTaxOfficeProfileOverviewDto> {
        let url_ = this.baseUrl + "/api/services/data-analytics/DataAnalyticsTaxOfficeProfiles/GetOverview?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (taxOfficeNamesFilter === null)
            throw new Error("The parameter 'taxOfficeNamesFilter' cannot be null.");
        else if (taxOfficeNamesFilter !== undefined)
            taxOfficeNamesFilter && taxOfficeNamesFilter.forEach(item => { url_ += "TaxOfficeNamesFilter=" + encodeURIComponent("" + item) + "&"; });
        if (countryFilter === null)
            throw new Error("The parameter 'countryFilter' cannot be null.");
        else if (countryFilter !== undefined)
            countryFilter && countryFilter.forEach(item => { url_ += "CountryFilter=" + encodeURIComponent("" + item) + "&"; });
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOverview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOverview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfTaxOfficeProfileOverviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfTaxOfficeProfileOverviewDto>;
        }));
    }

    protected processGetOverview(response: HttpResponseBase): Observable<PagedResultDtoOfTaxOfficeProfileOverviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfTaxOfficeProfileOverviewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getActive(): Observable<TaxOfficeProfileDto[]> {
        let url_ = this.baseUrl + "/api/services/data-analytics/DataAnalyticsTaxOfficeProfiles/GetActive";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActive(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaxOfficeProfileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaxOfficeProfileDto[]>;
        }));
    }

    protected processGetActive(response: HttpResponseBase): Observable<TaxOfficeProfileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TaxOfficeProfileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getById(id: number | undefined): Observable<TaxOfficeProfileDto> {
        let url_ = this.baseUrl + "/api/services/data-analytics/DataAnalyticsTaxOfficeProfiles/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaxOfficeProfileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaxOfficeProfileDto>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<TaxOfficeProfileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaxOfficeProfileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateTaxOfficeProfileInput | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/data-analytics/DataAnalyticsTaxOfficeProfiles/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateTaxOfficeProfileInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/data-analytics/DataAnalyticsTaxOfficeProfiles/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param file (optional) 
     * @return Success
     */
    uploadFile(file: FileParameter | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/data-analytics/DataAnalyticsTaxOfficeProfiles/UploadFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUploadFile(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/data-analytics/DataAnalyticsTaxOfficeProfiles/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DataAnalyticsTaxOfficeReferenceDataServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(DA_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getTaxOfficeConfigurations(): Observable<TaxOfficeConfiguration[]> {
        let url_ = this.baseUrl + "/api/services/data-analytics/DataAnalyticsTaxOfficeReferenceData/GetTaxOfficeConfigurations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTaxOfficeConfigurations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaxOfficeConfigurations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaxOfficeConfiguration[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaxOfficeConfiguration[]>;
        }));
    }

    protected processGetTaxOfficeConfigurations(response: HttpResponseBase): Observable<TaxOfficeConfiguration[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TaxOfficeConfiguration.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getTaxAuthorityTypes(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/data-analytics/DataAnalyticsTaxOfficeReferenceData/GetTaxAuthorityTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTaxAuthorityTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaxAuthorityTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetTaxAuthorityTypes(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getTaxOfficeConfig(): Observable<TaxOffice> {
        let url_ = this.baseUrl + "/api/services/data-analytics/DataAnalyticsTaxOfficeReferenceData/GetTaxOfficeConfig";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTaxOfficeConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaxOfficeConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaxOffice>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaxOffice>;
        }));
    }

    protected processGetTaxOfficeConfig(response: HttpResponseBase): Observable<TaxOffice> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaxOffice.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EinspruchLookupServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(DA_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param referenceId (optional) 
     * @return Success
     */
    getSurveys(referenceId: number | undefined): Observable<SurveyLookupDto[]> {
        let url_ = this.baseUrl + "/api/services/data-analytics/EinspruchLookup/GetSurveys?";
        if (referenceId === null)
            throw new Error("The parameter 'referenceId' cannot be null.");
        else if (referenceId !== undefined)
            url_ += "referenceId=" + encodeURIComponent("" + referenceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSurveys(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSurveys(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SurveyLookupDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SurveyLookupDto[]>;
        }));
    }

    protected processGetSurveys(response: HttpResponseBase): Observable<SurveyLookupDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SurveyLookupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getTenantUsers(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/data-analytics/EinspruchLookup/GetTenantUsers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetTenantUsers(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param referenceId (optional) 
     * @return Success
     */
    getAttachments(referenceId: number | undefined): Observable<AttachmentLookupDto[]> {
        let url_ = this.baseUrl + "/api/services/data-analytics/EinspruchLookup/GetAttachments?";
        if (referenceId === null)
            throw new Error("The parameter 'referenceId' cannot be null.");
        else if (referenceId !== undefined)
            url_ += "referenceId=" + encodeURIComponent("" + referenceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttachments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttachments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AttachmentLookupDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AttachmentLookupDto[]>;
        }));
    }

    protected processGetAttachments(response: HttpResponseBase): Observable<AttachmentLookupDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AttachmentLookupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EinspruchsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(DA_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createEinspruchAsWord(body: EinspruchRequest | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/data-analytics/Einspruchs/CreateEinspruchAsWord";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateEinspruchAsWord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateEinspruchAsWord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateEinspruchAsWord(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    submitEinspruchToEric(body: EricSubmissionRequest | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/data-analytics/Einspruchs/SubmitEinspruchToEric";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubmitEinspruchToEric(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmitEinspruchToEric(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSubmitEinspruchToEric(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param assignedUsersFilter (optional) 
     * @param federalStateFilter (optional) 
     * @param contactPersonFilter (optional) 
     * @param tagsFilter (optional) 
     * @param propertyOwnerFilter (optional) 
     * @param einspruchId (optional) 
     * @param showArchived (optional) 
     * @param einspruchStatusFilter (optional) 
     * @param authorizedReceivingAgentFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, assignedUsersFilter: number[] | undefined, federalStateFilter: string[] | undefined, contactPersonFilter: string[] | undefined, tagsFilter: string[] | undefined, propertyOwnerFilter: number[] | undefined, einspruchId: number | undefined, showArchived: boolean | undefined, einspruchStatusFilter: number[] | undefined, authorizedReceivingAgentFilter: number[] | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<MazarsPagedResultDtoOfEinspruchOverviewDto> {
        let url_ = this.baseUrl + "/api/services/data-analytics/Einspruchs/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (assignedUsersFilter === null)
            throw new Error("The parameter 'assignedUsersFilter' cannot be null.");
        else if (assignedUsersFilter !== undefined)
            assignedUsersFilter && assignedUsersFilter.forEach(item => { url_ += "AssignedUsersFilter=" + encodeURIComponent("" + item) + "&"; });
        if (federalStateFilter === null)
            throw new Error("The parameter 'federalStateFilter' cannot be null.");
        else if (federalStateFilter !== undefined)
            federalStateFilter && federalStateFilter.forEach(item => { url_ += "FederalStateFilter=" + encodeURIComponent("" + item) + "&"; });
        if (contactPersonFilter === null)
            throw new Error("The parameter 'contactPersonFilter' cannot be null.");
        else if (contactPersonFilter !== undefined)
            contactPersonFilter && contactPersonFilter.forEach(item => { url_ += "ContactPersonFilter=" + encodeURIComponent("" + item) + "&"; });
        if (tagsFilter === null)
            throw new Error("The parameter 'tagsFilter' cannot be null.");
        else if (tagsFilter !== undefined)
            tagsFilter && tagsFilter.forEach(item => { url_ += "TagsFilter=" + encodeURIComponent("" + item) + "&"; });
        if (propertyOwnerFilter === null)
            throw new Error("The parameter 'propertyOwnerFilter' cannot be null.");
        else if (propertyOwnerFilter !== undefined)
            propertyOwnerFilter && propertyOwnerFilter.forEach(item => { url_ += "PropertyOwnerFilter=" + encodeURIComponent("" + item) + "&"; });
        if (einspruchId === null)
            throw new Error("The parameter 'einspruchId' cannot be null.");
        else if (einspruchId !== undefined)
            url_ += "EinspruchId=" + encodeURIComponent("" + einspruchId) + "&";
        if (showArchived === null)
            throw new Error("The parameter 'showArchived' cannot be null.");
        else if (showArchived !== undefined)
            url_ += "ShowArchived=" + encodeURIComponent("" + showArchived) + "&";
        if (einspruchStatusFilter === null)
            throw new Error("The parameter 'einspruchStatusFilter' cannot be null.");
        else if (einspruchStatusFilter !== undefined)
            einspruchStatusFilter && einspruchStatusFilter.forEach(item => { url_ += "EinspruchStatusFilter=" + encodeURIComponent("" + item) + "&"; });
        if (authorizedReceivingAgentFilter === null)
            throw new Error("The parameter 'authorizedReceivingAgentFilter' cannot be null.");
        else if (authorizedReceivingAgentFilter !== undefined)
            authorizedReceivingAgentFilter && authorizedReceivingAgentFilter.forEach(item => { url_ += "AuthorizedReceivingAgentFilter=" + encodeURIComponent("" + item) + "&"; });
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MazarsPagedResultDtoOfEinspruchOverviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MazarsPagedResultDtoOfEinspruchOverviewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<MazarsPagedResultDtoOfEinspruchOverviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MazarsPagedResultDtoOfEinspruchOverviewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @return Success
     */
    getTags(filter: string | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/data-analytics/Einspruchs/GetTags?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTags(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTags(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetTags(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getGermanFederalStates(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/data-analytics/Einspruchs/GetGermanFederalStates";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGermanFederalStates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGermanFederalStates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetGermanFederalStates(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getById(id: number | undefined): Observable<EinspruchDto> {
        let url_ = this.baseUrl + "/api/services/data-analytics/Einspruchs/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EinspruchDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EinspruchDto>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<EinspruchDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EinspruchDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateEinspruchInput | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/data-analytics/Einspruchs/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateEinspruchInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/data-analytics/Einspruchs/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/data-analytics/Einspruchs/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    toggleAccessRestriction(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/data-analytics/Einspruchs/ToggleAccessRestriction?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processToggleAccessRestriction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processToggleAccessRestriction(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processToggleAccessRestriction(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param taxNumber (optional) 
     * @return Success
     */
    getTaxAuthorityTaxNumber(taxNumber: string | undefined): Observable<TaxAuthorityDto> {
        let url_ = this.baseUrl + "/api/services/data-analytics/Einspruchs/GetTaxAuthorityTaxNumber?";
        if (taxNumber === null)
            throw new Error("The parameter 'taxNumber' cannot be null.");
        else if (taxNumber !== undefined)
            url_ += "taxNumber=" + encodeURIComponent("" + taxNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTaxAuthorityTaxNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaxAuthorityTaxNumber(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TaxAuthorityDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TaxAuthorityDto>;
        }));
    }

    protected processGetTaxAuthorityTaxNumber(response: HttpResponseBase): Observable<TaxAuthorityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaxAuthorityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param taxNumber (optional) 
     * @param federalState (optional) 
     * @return Success
     */
    checkTaxNumber(taxNumber: string | undefined, federalState: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/data-analytics/Einspruchs/CheckTaxNumber?";
        if (taxNumber === null)
            throw new Error("The parameter 'taxNumber' cannot be null.");
        else if (taxNumber !== undefined)
            url_ += "taxNumber=" + encodeURIComponent("" + taxNumber) + "&";
        if (federalState === null)
            throw new Error("The parameter 'federalState' cannot be null.");
        else if (federalState !== undefined)
            url_ += "federalState=" + encodeURIComponent("" + federalState) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckTaxNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckTaxNumber(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCheckTaxNumber(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class NoticesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(DA_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    test(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/data-analytics/Notices/Test";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processTest(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    test2(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/data-analytics/Notices/Test2";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTest2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTest2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processTest2(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ValuesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(DA_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getAllValues(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/data-analytics/Values/GetAllValues";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetAllValues(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getHighchartsGERMapData(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/data-analytics/Values/GetHighchartsGERMapData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHighchartsGERMapData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHighchartsGERMapData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetHighchartsGERMapData(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class APAddress implements IAPAddress {
    street!: string | undefined;
    houseNumber!: string | undefined;
    zipCode!: string | undefined;
    city!: string | undefined;

    constructor(data?: IAPAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.street = _data["street"];
            this.houseNumber = _data["houseNumber"];
            this.zipCode = _data["zipCode"];
            this.city = _data["city"];
        }
    }

    static fromJS(data: any): APAddress {
        data = typeof data === 'object' ? data : {};
        let result = new APAddress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["street"] = this.street;
        data["houseNumber"] = this.houseNumber;
        data["zipCode"] = this.zipCode;
        data["city"] = this.city;
        return data;
    }
}

export interface IAPAddress {
    street: string | undefined;
    houseNumber: string | undefined;
    zipCode: string | undefined;
    city: string | undefined;
}

export class APDetails implements IAPDetails {
    lastName!: string | undefined;
    firstName!: string | undefined;
    gender!: string | undefined;
    phoneNumber!: string | undefined;
    email!: string | undefined;
    address!: APAddress;

    constructor(data?: IAPDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lastName = _data["lastName"];
            this.firstName = _data["firstName"];
            this.gender = _data["gender"];
            this.phoneNumber = _data["phoneNumber"];
            this.email = _data["email"];
            this.address = _data["address"] ? APAddress.fromJS(_data["address"]) : <any>undefined;
        }
    }

    static fromJS(data: any): APDetails {
        data = typeof data === 'object' ? data : {};
        let result = new APDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lastName"] = this.lastName;
        data["firstName"] = this.firstName;
        data["gender"] = this.gender;
        data["phoneNumber"] = this.phoneNumber;
        data["email"] = this.email;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAPDetails {
    lastName: string | undefined;
    firstName: string | undefined;
    gender: string | undefined;
    phoneNumber: string | undefined;
    email: string | undefined;
    address: APAddress;
}

export class AddressDto implements IAddressDto {
    street!: string | undefined;
    floor!: string | undefined;
    suite!: string | undefined;
    district!: string | undefined;
    postbox!: string | undefined;
    buildingIdentifier!: string | undefined;
    city!: string | undefined;
    countryCode!: string | undefined;
    postalCode!: string | undefined;

    constructor(data?: IAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.street = _data["street"];
            this.floor = _data["floor"];
            this.suite = _data["suite"];
            this.district = _data["district"];
            this.postbox = _data["postbox"];
            this.buildingIdentifier = _data["buildingIdentifier"];
            this.city = _data["city"];
            this.countryCode = _data["countryCode"];
            this.postalCode = _data["postalCode"];
        }
    }

    static fromJS(data: any): AddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["street"] = this.street;
        data["floor"] = this.floor;
        data["suite"] = this.suite;
        data["district"] = this.district;
        data["postbox"] = this.postbox;
        data["buildingIdentifier"] = this.buildingIdentifier;
        data["city"] = this.city;
        data["countryCode"] = this.countryCode;
        data["postalCode"] = this.postalCode;
        return data;
    }
}

export interface IAddressDto {
    street: string | undefined;
    floor: string | undefined;
    suite: string | undefined;
    district: string | undefined;
    postbox: string | undefined;
    buildingIdentifier: string | undefined;
    city: string | undefined;
    countryCode: string | undefined;
    postalCode: string | undefined;
}

export class AssignableUserDto implements IAssignableUserDto {
    id!: number;
    fullName!: string | undefined;
    userName!: string | undefined;

    constructor(data?: IAssignableUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fullName = _data["fullName"];
            this.userName = _data["userName"];
        }
    }

    static fromJS(data: any): AssignableUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssignableUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fullName"] = this.fullName;
        data["userName"] = this.userName;
        return data;
    }
}

export interface IAssignableUserDto {
    id: number;
    fullName: string | undefined;
    userName: string | undefined;
}

export class AttachmentLookupDto implements IAttachmentLookupDto {
    id!: number;
    name!: string | undefined;

    constructor(data?: IAttachmentLookupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): AttachmentLookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttachmentLookupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IAttachmentLookupDto {
    id: number;
    name: string | undefined;
}

export class ChancelleryViewAdminSettings implements IChancelleryViewAdminSettings {
    isChancelleryViewActive!: boolean;
    chancelleryViewClientsEndpointUrl!: string | undefined;
    chancelleryViewProjectsEndpointUrl!: string | undefined;
    chancelleryViewUsername!: string | undefined;
    chancelleryViewPassword!: string | undefined;
    chancelleryViewIsClientRequired!: boolean;
    chancelleryViewIsProjectRequired!: boolean;

    constructor(data?: IChancelleryViewAdminSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isChancelleryViewActive = _data["isChancelleryViewActive"];
            this.chancelleryViewClientsEndpointUrl = _data["chancelleryViewClientsEndpointUrl"];
            this.chancelleryViewProjectsEndpointUrl = _data["chancelleryViewProjectsEndpointUrl"];
            this.chancelleryViewUsername = _data["chancelleryViewUsername"];
            this.chancelleryViewPassword = _data["chancelleryViewPassword"];
            this.chancelleryViewIsClientRequired = _data["chancelleryViewIsClientRequired"];
            this.chancelleryViewIsProjectRequired = _data["chancelleryViewIsProjectRequired"];
        }
    }

    static fromJS(data: any): ChancelleryViewAdminSettings {
        data = typeof data === 'object' ? data : {};
        let result = new ChancelleryViewAdminSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isChancelleryViewActive"] = this.isChancelleryViewActive;
        data["chancelleryViewClientsEndpointUrl"] = this.chancelleryViewClientsEndpointUrl;
        data["chancelleryViewProjectsEndpointUrl"] = this.chancelleryViewProjectsEndpointUrl;
        data["chancelleryViewUsername"] = this.chancelleryViewUsername;
        data["chancelleryViewPassword"] = this.chancelleryViewPassword;
        data["chancelleryViewIsClientRequired"] = this.chancelleryViewIsClientRequired;
        data["chancelleryViewIsProjectRequired"] = this.chancelleryViewIsProjectRequired;
        return data;
    }
}

export interface IChancelleryViewAdminSettings {
    isChancelleryViewActive: boolean;
    chancelleryViewClientsEndpointUrl: string | undefined;
    chancelleryViewProjectsEndpointUrl: string | undefined;
    chancelleryViewUsername: string | undefined;
    chancelleryViewPassword: string | undefined;
    chancelleryViewIsClientRequired: boolean;
    chancelleryViewIsProjectRequired: boolean;
}

export class CreateEinspruchInput implements ICreateEinspruchInput {
    general!: GeneralArchivableInput;
    specifics!: EinspruchSpecificInput;

    constructor(data?: ICreateEinspruchInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.general = _data["general"] ? GeneralArchivableInput.fromJS(_data["general"]) : <any>undefined;
            this.specifics = _data["specifics"] ? EinspruchSpecificInput.fromJS(_data["specifics"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateEinspruchInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEinspruchInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["general"] = this.general ? this.general.toJSON() : <any>undefined;
        data["specifics"] = this.specifics ? this.specifics.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateEinspruchInput {
    general: GeneralArchivableInput;
    specifics: EinspruchSpecificInput;
}

export class CreateTaxOfficeProfileInput implements ICreateTaxOfficeProfileInput {
    taxOfficeId!: string | undefined;
    profileName!: string | undefined;
    expirationDate!: DateTime;
    credentialInfo!: CredentialInfoInput;
    fileToken!: string | undefined;

    constructor(data?: ICreateTaxOfficeProfileInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taxOfficeId = _data["taxOfficeId"];
            this.profileName = _data["profileName"];
            this.expirationDate = _data["expirationDate"] ? DateTime.fromISO(_data["expirationDate"].toString()) : <any>undefined;
            this.credentialInfo = _data["credentialInfo"] ? CredentialInfoInput.fromJS(_data["credentialInfo"]) : <any>undefined;
            this.fileToken = _data["fileToken"];
        }
    }

    static fromJS(data: any): CreateTaxOfficeProfileInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTaxOfficeProfileInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taxOfficeId"] = this.taxOfficeId;
        data["profileName"] = this.profileName;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toString() : <any>undefined;
        data["credentialInfo"] = this.credentialInfo ? this.credentialInfo.toJSON() : <any>undefined;
        data["fileToken"] = this.fileToken;
        return data;
    }
}

export interface ICreateTaxOfficeProfileInput {
    taxOfficeId: string | undefined;
    profileName: string | undefined;
    expirationDate: DateTime;
    credentialInfo: CredentialInfoInput;
    fileToken: string | undefined;
}

export class CredentialInfoDto implements ICredentialInfoDto {
    username!: string | undefined;
    passphrase!: string | undefined;
    certificate!: string | undefined;

    constructor(data?: ICredentialInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.passphrase = _data["passphrase"];
            this.certificate = _data["certificate"];
        }
    }

    static fromJS(data: any): CredentialInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new CredentialInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["passphrase"] = this.passphrase;
        data["certificate"] = this.certificate;
        return data;
    }
}

export interface ICredentialInfoDto {
    username: string | undefined;
    passphrase: string | undefined;
    certificate: string | undefined;
}

export class CredentialInfoInput implements ICredentialInfoInput {
    username!: string | undefined;
    passphrase!: string | undefined;
    certificate!: string | undefined;

    constructor(data?: ICredentialInfoInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.passphrase = _data["passphrase"];
            this.certificate = _data["certificate"];
        }
    }

    static fromJS(data: any): CredentialInfoInput {
        data = typeof data === 'object' ? data : {};
        let result = new CredentialInfoInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["passphrase"] = this.passphrase;
        data["certificate"] = this.certificate;
        return data;
    }
}

export interface ICredentialInfoInput {
    username: string | undefined;
    passphrase: string | undefined;
    certificate: string | undefined;
}

export enum Criticality {
    VeryLow = 1,
    Low = 2,
    Medium = 3,
    High = 4,
}

export class DataAnalyticsAdminSettingsDto implements IDataAnalyticsAdminSettingsDto {
    isAccessRestriction!: boolean;
    chancelleryViewAdminSettings!: ChancelleryViewAdminSettings;
    isAdditionalForCreateDeclaration!: boolean;
    isAdditionalForEditDeclaration!: boolean;
    isAdditionalForSubmission!: boolean;
    isReviewEditDeclaration!: boolean;
    isReviewEditDeclarationFourEyes!: boolean;
    isAdditionalForReviewEditDeclaration!: boolean;
    isMandatoryInternalIdDeclaration!: boolean;
    isMandatoryInternalIdEinspruch!: boolean;
    dueDateFirstReminder!: number;
    dueDateHasExceeded!: boolean;
    dueDateFirstReminderActive!: boolean;

    constructor(data?: IDataAnalyticsAdminSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isAccessRestriction = _data["isAccessRestriction"];
            this.chancelleryViewAdminSettings = _data["chancelleryViewAdminSettings"] ? ChancelleryViewAdminSettings.fromJS(_data["chancelleryViewAdminSettings"]) : <any>undefined;
            this.isAdditionalForCreateDeclaration = _data["isAdditionalForCreateDeclaration"];
            this.isAdditionalForEditDeclaration = _data["isAdditionalForEditDeclaration"];
            this.isAdditionalForSubmission = _data["isAdditionalForSubmission"];
            this.isReviewEditDeclaration = _data["isReviewEditDeclaration"];
            this.isReviewEditDeclarationFourEyes = _data["isReviewEditDeclarationFourEyes"];
            this.isAdditionalForReviewEditDeclaration = _data["isAdditionalForReviewEditDeclaration"];
            this.isMandatoryInternalIdDeclaration = _data["isMandatoryInternalIdDeclaration"];
            this.isMandatoryInternalIdEinspruch = _data["isMandatoryInternalIdEinspruch"];
            this.dueDateFirstReminder = _data["dueDateFirstReminder"];
            this.dueDateHasExceeded = _data["dueDateHasExceeded"];
            this.dueDateFirstReminderActive = _data["dueDateFirstReminderActive"];
        }
    }

    static fromJS(data: any): DataAnalyticsAdminSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new DataAnalyticsAdminSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isAccessRestriction"] = this.isAccessRestriction;
        data["chancelleryViewAdminSettings"] = this.chancelleryViewAdminSettings ? this.chancelleryViewAdminSettings.toJSON() : <any>undefined;
        data["isAdditionalForCreateDeclaration"] = this.isAdditionalForCreateDeclaration;
        data["isAdditionalForEditDeclaration"] = this.isAdditionalForEditDeclaration;
        data["isAdditionalForSubmission"] = this.isAdditionalForSubmission;
        data["isReviewEditDeclaration"] = this.isReviewEditDeclaration;
        data["isReviewEditDeclarationFourEyes"] = this.isReviewEditDeclarationFourEyes;
        data["isAdditionalForReviewEditDeclaration"] = this.isAdditionalForReviewEditDeclaration;
        data["isMandatoryInternalIdDeclaration"] = this.isMandatoryInternalIdDeclaration;
        data["isMandatoryInternalIdEinspruch"] = this.isMandatoryInternalIdEinspruch;
        data["dueDateFirstReminder"] = this.dueDateFirstReminder;
        data["dueDateHasExceeded"] = this.dueDateHasExceeded;
        data["dueDateFirstReminderActive"] = this.dueDateFirstReminderActive;
        return data;
    }
}

export interface IDataAnalyticsAdminSettingsDto {
    isAccessRestriction: boolean;
    chancelleryViewAdminSettings: ChancelleryViewAdminSettings;
    isAdditionalForCreateDeclaration: boolean;
    isAdditionalForEditDeclaration: boolean;
    isAdditionalForSubmission: boolean;
    isReviewEditDeclaration: boolean;
    isReviewEditDeclarationFourEyes: boolean;
    isAdditionalForReviewEditDeclaration: boolean;
    isMandatoryInternalIdDeclaration: boolean;
    isMandatoryInternalIdEinspruch: boolean;
    dueDateFirstReminder: number;
    dueDateHasExceeded: boolean;
    dueDateFirstReminderActive: boolean;
}

export class DataAnalyticsAdminSettingsInput implements IDataAnalyticsAdminSettingsInput {
    isAccessRestriction!: boolean;
    chancelleryViewAdminSettings!: ChancelleryViewAdminSettings;
    isAdditionalForCreateDeclaration!: boolean;
    isAdditionalForEditDeclaration!: boolean;
    isAdditionalForSubmission!: boolean;
    isReviewEditDeclaration!: boolean;
    isReviewEditDeclarationFourEyes!: boolean;
    isAdditionalForReviewEditDeclaration!: boolean;
    isMandatoryInternalIdDeclaration!: boolean;
    isMandatoryInternalIdEinspruch!: boolean;
    dueDateFirstReminder!: number;
    dueDateHasExceeded!: boolean;
    dueDateFirstReminderActive!: boolean;

    constructor(data?: IDataAnalyticsAdminSettingsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isAccessRestriction = _data["isAccessRestriction"];
            this.chancelleryViewAdminSettings = _data["chancelleryViewAdminSettings"] ? ChancelleryViewAdminSettings.fromJS(_data["chancelleryViewAdminSettings"]) : <any>undefined;
            this.isAdditionalForCreateDeclaration = _data["isAdditionalForCreateDeclaration"];
            this.isAdditionalForEditDeclaration = _data["isAdditionalForEditDeclaration"];
            this.isAdditionalForSubmission = _data["isAdditionalForSubmission"];
            this.isReviewEditDeclaration = _data["isReviewEditDeclaration"];
            this.isReviewEditDeclarationFourEyes = _data["isReviewEditDeclarationFourEyes"];
            this.isAdditionalForReviewEditDeclaration = _data["isAdditionalForReviewEditDeclaration"];
            this.isMandatoryInternalIdDeclaration = _data["isMandatoryInternalIdDeclaration"];
            this.isMandatoryInternalIdEinspruch = _data["isMandatoryInternalIdEinspruch"];
            this.dueDateFirstReminder = _data["dueDateFirstReminder"];
            this.dueDateHasExceeded = _data["dueDateHasExceeded"];
            this.dueDateFirstReminderActive = _data["dueDateFirstReminderActive"];
        }
    }

    static fromJS(data: any): DataAnalyticsAdminSettingsInput {
        data = typeof data === 'object' ? data : {};
        let result = new DataAnalyticsAdminSettingsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isAccessRestriction"] = this.isAccessRestriction;
        data["chancelleryViewAdminSettings"] = this.chancelleryViewAdminSettings ? this.chancelleryViewAdminSettings.toJSON() : <any>undefined;
        data["isAdditionalForCreateDeclaration"] = this.isAdditionalForCreateDeclaration;
        data["isAdditionalForEditDeclaration"] = this.isAdditionalForEditDeclaration;
        data["isAdditionalForSubmission"] = this.isAdditionalForSubmission;
        data["isReviewEditDeclaration"] = this.isReviewEditDeclaration;
        data["isReviewEditDeclarationFourEyes"] = this.isReviewEditDeclarationFourEyes;
        data["isAdditionalForReviewEditDeclaration"] = this.isAdditionalForReviewEditDeclaration;
        data["isMandatoryInternalIdDeclaration"] = this.isMandatoryInternalIdDeclaration;
        data["isMandatoryInternalIdEinspruch"] = this.isMandatoryInternalIdEinspruch;
        data["dueDateFirstReminder"] = this.dueDateFirstReminder;
        data["dueDateHasExceeded"] = this.dueDateHasExceeded;
        data["dueDateFirstReminderActive"] = this.dueDateFirstReminderActive;
        return data;
    }
}

export interface IDataAnalyticsAdminSettingsInput {
    isAccessRestriction: boolean;
    chancelleryViewAdminSettings: ChancelleryViewAdminSettings;
    isAdditionalForCreateDeclaration: boolean;
    isAdditionalForEditDeclaration: boolean;
    isAdditionalForSubmission: boolean;
    isReviewEditDeclaration: boolean;
    isReviewEditDeclarationFourEyes: boolean;
    isAdditionalForReviewEditDeclaration: boolean;
    isMandatoryInternalIdDeclaration: boolean;
    isMandatoryInternalIdEinspruch: boolean;
    dueDateFirstReminder: number;
    dueDateHasExceeded: boolean;
    dueDateFirstReminderActive: boolean;
}

export class EinspruchAccessAndPermissionDto implements IEinspruchAccessAndPermissionDto {
    accessRestrictionPossibleUsers!: UserOrOrganizationUnitDto[] | undefined;
    selectedAccessRestrictionPossibleUsers!: UserOrOrganizationUnitDto[] | undefined;
    isAccessRestrictionActive!: boolean;
    customPermissions!: EntityPermissionDto[] | undefined;
    isReviewEditDeclaration!: boolean;
    isReviewEditDeclarationFourEyes!: boolean;

    constructor(data?: IEinspruchAccessAndPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["accessRestrictionPossibleUsers"])) {
                this.accessRestrictionPossibleUsers = [] as any;
                for (let item of _data["accessRestrictionPossibleUsers"])
                    this.accessRestrictionPossibleUsers!.push(UserOrOrganizationUnitDto.fromJS(item));
            }
            if (Array.isArray(_data["selectedAccessRestrictionPossibleUsers"])) {
                this.selectedAccessRestrictionPossibleUsers = [] as any;
                for (let item of _data["selectedAccessRestrictionPossibleUsers"])
                    this.selectedAccessRestrictionPossibleUsers!.push(UserOrOrganizationUnitDto.fromJS(item));
            }
            this.isAccessRestrictionActive = _data["isAccessRestrictionActive"];
            if (Array.isArray(_data["customPermissions"])) {
                this.customPermissions = [] as any;
                for (let item of _data["customPermissions"])
                    this.customPermissions!.push(EntityPermissionDto.fromJS(item));
            }
            this.isReviewEditDeclaration = _data["isReviewEditDeclaration"];
            this.isReviewEditDeclarationFourEyes = _data["isReviewEditDeclarationFourEyes"];
        }
    }

    static fromJS(data: any): EinspruchAccessAndPermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new EinspruchAccessAndPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.accessRestrictionPossibleUsers)) {
            data["accessRestrictionPossibleUsers"] = [];
            for (let item of this.accessRestrictionPossibleUsers)
                data["accessRestrictionPossibleUsers"].push(item.toJSON());
        }
        if (Array.isArray(this.selectedAccessRestrictionPossibleUsers)) {
            data["selectedAccessRestrictionPossibleUsers"] = [];
            for (let item of this.selectedAccessRestrictionPossibleUsers)
                data["selectedAccessRestrictionPossibleUsers"].push(item.toJSON());
        }
        data["isAccessRestrictionActive"] = this.isAccessRestrictionActive;
        if (Array.isArray(this.customPermissions)) {
            data["customPermissions"] = [];
            for (let item of this.customPermissions)
                data["customPermissions"].push(item.toJSON());
        }
        data["isReviewEditDeclaration"] = this.isReviewEditDeclaration;
        data["isReviewEditDeclarationFourEyes"] = this.isReviewEditDeclarationFourEyes;
        return data;
    }
}

export interface IEinspruchAccessAndPermissionDto {
    accessRestrictionPossibleUsers: UserOrOrganizationUnitDto[] | undefined;
    selectedAccessRestrictionPossibleUsers: UserOrOrganizationUnitDto[] | undefined;
    isAccessRestrictionActive: boolean;
    customPermissions: EntityPermissionDto[] | undefined;
    isReviewEditDeclaration: boolean;
    isReviewEditDeclarationFourEyes: boolean;
}

export class EinspruchDto implements IEinspruchDto {
    id!: number;
    general!: GeneralArchivableDto;
    accessAndPermission!: EinspruchAccessAndPermissionDto;
    projectManagement!: ProjectManagementInfoDto;
    specifics!: EinspruchSpecificDto;
    process!: ProcessDto;
    permissions!: string[] | undefined;
    isMandatoryInternalIdEinspruch!: boolean;
    internalId!: string | undefined;

    constructor(data?: IEinspruchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.general = _data["general"] ? GeneralArchivableDto.fromJS(_data["general"]) : <any>undefined;
            this.accessAndPermission = _data["accessAndPermission"] ? EinspruchAccessAndPermissionDto.fromJS(_data["accessAndPermission"]) : <any>undefined;
            this.projectManagement = _data["projectManagement"] ? ProjectManagementInfoDto.fromJS(_data["projectManagement"]) : <any>undefined;
            this.specifics = _data["specifics"] ? EinspruchSpecificDto.fromJS(_data["specifics"]) : <any>undefined;
            this.process = _data["process"] ? ProcessDto.fromJS(_data["process"]) : <any>undefined;
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
            this.isMandatoryInternalIdEinspruch = _data["isMandatoryInternalIdEinspruch"];
            this.internalId = _data["internalId"];
        }
    }

    static fromJS(data: any): EinspruchDto {
        data = typeof data === 'object' ? data : {};
        let result = new EinspruchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["general"] = this.general ? this.general.toJSON() : <any>undefined;
        data["accessAndPermission"] = this.accessAndPermission ? this.accessAndPermission.toJSON() : <any>undefined;
        data["projectManagement"] = this.projectManagement ? this.projectManagement.toJSON() : <any>undefined;
        data["specifics"] = this.specifics ? this.specifics.toJSON() : <any>undefined;
        data["process"] = this.process ? this.process.toJSON() : <any>undefined;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        data["isMandatoryInternalIdEinspruch"] = this.isMandatoryInternalIdEinspruch;
        data["internalId"] = this.internalId;
        return data;
    }
}

export interface IEinspruchDto {
    id: number;
    general: GeneralArchivableDto;
    accessAndPermission: EinspruchAccessAndPermissionDto;
    projectManagement: ProjectManagementInfoDto;
    specifics: EinspruchSpecificDto;
    process: ProcessDto;
    permissions: string[] | undefined;
    isMandatoryInternalIdEinspruch: boolean;
    internalId: string | undefined;
}

export class EinspruchOverviewDto implements IEinspruchOverviewDto {
    id!: number;
    name!: string | undefined;
    federalState!: string | undefined;
    tags!: TagDto[] | undefined;
    assignedUser!: AssignableUserDto;
    creationDate!: DateTime;
    address!: AddressDto;
    lastModifier!: string | undefined;
    lastModifierUserId!: number | undefined;
    lastModificationTime!: DateTime | undefined;
    isArchived!: boolean;
    mainTaxNumber!: string | undefined;
    mandantennummer!: string | undefined;
    ansprechpartner!: string | undefined;
    noticesBase64!: string[] | undefined;
    einspruchAsDocxBase64!: string | undefined;
    einspruchAsDocxFilename!: string | undefined;
    stampedEinspruchBase64!: string | undefined;
    protocolFileBase64!: string | undefined;

    constructor(data?: IEinspruchOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.federalState = _data["federalState"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(TagDto.fromJS(item));
            }
            this.assignedUser = _data["assignedUser"] ? AssignableUserDto.fromJS(_data["assignedUser"]) : <any>undefined;
            this.creationDate = _data["creationDate"] ? DateTime.fromISO(_data["creationDate"].toString()) : <any>undefined;
            this.address = _data["address"] ? AddressDto.fromJS(_data["address"]) : <any>undefined;
            this.lastModifier = _data["lastModifier"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.isArchived = _data["isArchived"];
            this.mainTaxNumber = _data["mainTaxNumber"];
            this.mandantennummer = _data["mandantennummer"];
            this.ansprechpartner = _data["ansprechpartner"];
            if (Array.isArray(_data["noticesBase64"])) {
                this.noticesBase64 = [] as any;
                for (let item of _data["noticesBase64"])
                    this.noticesBase64!.push(item);
            }
            this.einspruchAsDocxBase64 = _data["einspruchAsDocxBase64"];
            this.einspruchAsDocxFilename = _data["einspruchAsDocxFilename"];
            this.stampedEinspruchBase64 = _data["stampedEinspruchBase64"];
            this.protocolFileBase64 = _data["protocolFileBase64"];
        }
    }

    static fromJS(data: any): EinspruchOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new EinspruchOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["federalState"] = this.federalState;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        data["assignedUser"] = this.assignedUser ? this.assignedUser.toJSON() : <any>undefined;
        data["creationDate"] = this.creationDate ? this.creationDate.toString() : <any>undefined;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["lastModifier"] = this.lastModifier;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["isArchived"] = this.isArchived;
        data["mainTaxNumber"] = this.mainTaxNumber;
        data["mandantennummer"] = this.mandantennummer;
        data["ansprechpartner"] = this.ansprechpartner;
        if (Array.isArray(this.noticesBase64)) {
            data["noticesBase64"] = [];
            for (let item of this.noticesBase64)
                data["noticesBase64"].push(item);
        }
        data["einspruchAsDocxBase64"] = this.einspruchAsDocxBase64;
        data["einspruchAsDocxFilename"] = this.einspruchAsDocxFilename;
        data["stampedEinspruchBase64"] = this.stampedEinspruchBase64;
        data["protocolFileBase64"] = this.protocolFileBase64;
        return data;
    }
}

export interface IEinspruchOverviewDto {
    id: number;
    name: string | undefined;
    federalState: string | undefined;
    tags: TagDto[] | undefined;
    assignedUser: AssignableUserDto;
    creationDate: DateTime;
    address: AddressDto;
    lastModifier: string | undefined;
    lastModifierUserId: number | undefined;
    lastModificationTime: DateTime | undefined;
    isArchived: boolean;
    mainTaxNumber: string | undefined;
    mandantennummer: string | undefined;
    ansprechpartner: string | undefined;
    noticesBase64: string[] | undefined;
    einspruchAsDocxBase64: string | undefined;
    einspruchAsDocxFilename: string | undefined;
    stampedEinspruchBase64: string | undefined;
    protocolFileBase64: string | undefined;
}

export class EinspruchRequest implements IEinspruchRequest {
    mandantennummer!: string | undefined;
    ansprechpartner!: APDetails;
    inputNotices!: string[] | undefined;

    constructor(data?: IEinspruchRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mandantennummer = _data["mandantennummer"];
            this.ansprechpartner = _data["ansprechpartner"] ? APDetails.fromJS(_data["ansprechpartner"]) : <any>undefined;
            if (Array.isArray(_data["inputNotices"])) {
                this.inputNotices = [] as any;
                for (let item of _data["inputNotices"])
                    this.inputNotices!.push(item);
            }
        }
    }

    static fromJS(data: any): EinspruchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EinspruchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mandantennummer"] = this.mandantennummer;
        data["ansprechpartner"] = this.ansprechpartner ? this.ansprechpartner.toJSON() : <any>undefined;
        if (Array.isArray(this.inputNotices)) {
            data["inputNotices"] = [];
            for (let item of this.inputNotices)
                data["inputNotices"].push(item);
        }
        return data;
    }
}

export interface IEinspruchRequest {
    mandantennummer: string | undefined;
    ansprechpartner: APDetails;
    inputNotices: string[] | undefined;
}

export class EinspruchSpecificDto implements IEinspruchSpecificDto {
    street!: string | undefined;
    houseNumber!: string | undefined;
    city!: string | undefined;
    postalCode!: string | undefined;
    federalState!: string | undefined;
    mainTaxNumber!: string | undefined;
    mandantennummer!: string | undefined;
    ansprechpartner!: string | undefined;
    noticesBase64!: string[] | undefined;
    einspruchAsDocxBase64!: string | undefined;
    einspruchAsDocxFilename!: string | undefined;
    stampedEinspruchBase64!: string | undefined;
    protocolFileBase64!: string | undefined;

    constructor(data?: IEinspruchSpecificDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.street = _data["street"];
            this.houseNumber = _data["houseNumber"];
            this.city = _data["city"];
            this.postalCode = _data["postalCode"];
            this.federalState = _data["federalState"];
            this.mainTaxNumber = _data["mainTaxNumber"];
            this.mandantennummer = _data["mandantennummer"];
            this.ansprechpartner = _data["ansprechpartner"];
            if (Array.isArray(_data["noticesBase64"])) {
                this.noticesBase64 = [] as any;
                for (let item of _data["noticesBase64"])
                    this.noticesBase64!.push(item);
            }
            this.einspruchAsDocxBase64 = _data["einspruchAsDocxBase64"];
            this.einspruchAsDocxFilename = _data["einspruchAsDocxFilename"];
            this.stampedEinspruchBase64 = _data["stampedEinspruchBase64"];
            this.protocolFileBase64 = _data["protocolFileBase64"];
        }
    }

    static fromJS(data: any): EinspruchSpecificDto {
        data = typeof data === 'object' ? data : {};
        let result = new EinspruchSpecificDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["street"] = this.street;
        data["houseNumber"] = this.houseNumber;
        data["city"] = this.city;
        data["postalCode"] = this.postalCode;
        data["federalState"] = this.federalState;
        data["mainTaxNumber"] = this.mainTaxNumber;
        data["mandantennummer"] = this.mandantennummer;
        data["ansprechpartner"] = this.ansprechpartner;
        if (Array.isArray(this.noticesBase64)) {
            data["noticesBase64"] = [];
            for (let item of this.noticesBase64)
                data["noticesBase64"].push(item);
        }
        data["einspruchAsDocxBase64"] = this.einspruchAsDocxBase64;
        data["einspruchAsDocxFilename"] = this.einspruchAsDocxFilename;
        data["stampedEinspruchBase64"] = this.stampedEinspruchBase64;
        data["protocolFileBase64"] = this.protocolFileBase64;
        return data;
    }
}

export interface IEinspruchSpecificDto {
    street: string | undefined;
    houseNumber: string | undefined;
    city: string | undefined;
    postalCode: string | undefined;
    federalState: string | undefined;
    mainTaxNumber: string | undefined;
    mandantennummer: string | undefined;
    ansprechpartner: string | undefined;
    noticesBase64: string[] | undefined;
    einspruchAsDocxBase64: string | undefined;
    einspruchAsDocxFilename: string | undefined;
    stampedEinspruchBase64: string | undefined;
    protocolFileBase64: string | undefined;
}

export class EinspruchSpecificInput implements IEinspruchSpecificInput {
    street!: string | undefined;
    houseNumber!: string | undefined;
    postalCode!: string | undefined;
    city!: string | undefined;
    federalState!: string | undefined;
    mainTaxNumber!: string | undefined;
    mandantennummer!: string | undefined;
    ansprechpartner!: string | undefined;
    noticesBase64!: string[] | undefined;
    einspruchAsDocxBase64!: string | undefined;
    einspruchAsDocxFilename!: string | undefined;
    stampedEinspruchBase64!: string | undefined;
    protocolFileBase64!: string | undefined;

    constructor(data?: IEinspruchSpecificInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.street = _data["street"];
            this.houseNumber = _data["houseNumber"];
            this.postalCode = _data["postalCode"];
            this.city = _data["city"];
            this.federalState = _data["federalState"];
            this.mainTaxNumber = _data["mainTaxNumber"];
            this.mandantennummer = _data["mandantennummer"];
            this.ansprechpartner = _data["ansprechpartner"];
            if (Array.isArray(_data["noticesBase64"])) {
                this.noticesBase64 = [] as any;
                for (let item of _data["noticesBase64"])
                    this.noticesBase64!.push(item);
            }
            this.einspruchAsDocxBase64 = _data["einspruchAsDocxBase64"];
            this.einspruchAsDocxFilename = _data["einspruchAsDocxFilename"];
            this.stampedEinspruchBase64 = _data["stampedEinspruchBase64"];
            this.protocolFileBase64 = _data["protocolFileBase64"];
        }
    }

    static fromJS(data: any): EinspruchSpecificInput {
        data = typeof data === 'object' ? data : {};
        let result = new EinspruchSpecificInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["street"] = this.street;
        data["houseNumber"] = this.houseNumber;
        data["postalCode"] = this.postalCode;
        data["city"] = this.city;
        data["federalState"] = this.federalState;
        data["mainTaxNumber"] = this.mainTaxNumber;
        data["mandantennummer"] = this.mandantennummer;
        data["ansprechpartner"] = this.ansprechpartner;
        if (Array.isArray(this.noticesBase64)) {
            data["noticesBase64"] = [];
            for (let item of this.noticesBase64)
                data["noticesBase64"].push(item);
        }
        data["einspruchAsDocxBase64"] = this.einspruchAsDocxBase64;
        data["einspruchAsDocxFilename"] = this.einspruchAsDocxFilename;
        data["stampedEinspruchBase64"] = this.stampedEinspruchBase64;
        data["protocolFileBase64"] = this.protocolFileBase64;
        return data;
    }
}

export interface IEinspruchSpecificInput {
    street: string | undefined;
    houseNumber: string | undefined;
    postalCode: string | undefined;
    city: string | undefined;
    federalState: string | undefined;
    mainTaxNumber: string | undefined;
    mandantennummer: string | undefined;
    ansprechpartner: string | undefined;
    noticesBase64: string[] | undefined;
    einspruchAsDocxBase64: string | undefined;
    einspruchAsDocxFilename: string | undefined;
    stampedEinspruchBase64: string | undefined;
    protocolFileBase64: string | undefined;
}

export class EntityPermissionDto implements IEntityPermissionDto {
    referenceId!: number;
    permissionName!: string | undefined;
    isActive!: boolean;
    possibleUsers!: ListResultDtoOfUserOrOrganizationUnitDto;
    usersOrOrganizationUnits!: ListResultDtoOfUserOrOrganizationUnitDto;
    availableUsersOrOrganizationUnits!: ListResultDtoOfUserOrOrganizationUnitDto;

    constructor(data?: IEntityPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.referenceId = _data["referenceId"];
            this.permissionName = _data["permissionName"];
            this.isActive = _data["isActive"];
            this.possibleUsers = _data["possibleUsers"] ? ListResultDtoOfUserOrOrganizationUnitDto.fromJS(_data["possibleUsers"]) : <any>undefined;
            this.usersOrOrganizationUnits = _data["usersOrOrganizationUnits"] ? ListResultDtoOfUserOrOrganizationUnitDto.fromJS(_data["usersOrOrganizationUnits"]) : <any>undefined;
            this.availableUsersOrOrganizationUnits = _data["availableUsersOrOrganizationUnits"] ? ListResultDtoOfUserOrOrganizationUnitDto.fromJS(_data["availableUsersOrOrganizationUnits"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EntityPermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["referenceId"] = this.referenceId;
        data["permissionName"] = this.permissionName;
        data["isActive"] = this.isActive;
        data["possibleUsers"] = this.possibleUsers ? this.possibleUsers.toJSON() : <any>undefined;
        data["usersOrOrganizationUnits"] = this.usersOrOrganizationUnits ? this.usersOrOrganizationUnits.toJSON() : <any>undefined;
        data["availableUsersOrOrganizationUnits"] = this.availableUsersOrOrganizationUnits ? this.availableUsersOrOrganizationUnits.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEntityPermissionDto {
    referenceId: number;
    permissionName: string | undefined;
    isActive: boolean;
    possibleUsers: ListResultDtoOfUserOrOrganizationUnitDto;
    usersOrOrganizationUnits: ListResultDtoOfUserOrOrganizationUnitDto;
    availableUsersOrOrganizationUnits: ListResultDtoOfUserOrOrganizationUnitDto;
}

export class EricSubmissionRequest implements IEricSubmissionRequest {
    einspruchAsPdfBase64!: string | undefined;
    taxNumber!: string | undefined;
    ansprechpartner!: APDetails;

    constructor(data?: IEricSubmissionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.einspruchAsPdfBase64 = _data["einspruchAsPdfBase64"];
            this.taxNumber = _data["taxNumber"];
            this.ansprechpartner = _data["ansprechpartner"] ? APDetails.fromJS(_data["ansprechpartner"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EricSubmissionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EricSubmissionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["einspruchAsPdfBase64"] = this.einspruchAsPdfBase64;
        data["taxNumber"] = this.taxNumber;
        data["ansprechpartner"] = this.ansprechpartner ? this.ansprechpartner.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEricSubmissionRequest {
    einspruchAsPdfBase64: string | undefined;
    taxNumber: string | undefined;
    ansprechpartner: APDetails;
}

export class GeneralArchivableDto implements IGeneralArchivableDto {
    name!: string | undefined;
    note!: string | undefined;
    tags!: TagDto[] | undefined;
    isArchived!: boolean;

    constructor(data?: IGeneralArchivableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.note = _data["note"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(TagDto.fromJS(item));
            }
            this.isArchived = _data["isArchived"];
        }
    }

    static fromJS(data: any): GeneralArchivableDto {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralArchivableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["note"] = this.note;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        data["isArchived"] = this.isArchived;
        return data;
    }
}

export interface IGeneralArchivableDto {
    name: string | undefined;
    note: string | undefined;
    tags: TagDto[] | undefined;
    isArchived: boolean;
}

export class GeneralArchivableInput implements IGeneralArchivableInput {
    name!: string | undefined;
    note!: string | undefined;
    tags!: TagDto[] | undefined;
    isArchived!: boolean;

    constructor(data?: IGeneralArchivableInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.note = _data["note"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(TagDto.fromJS(item));
            }
            this.isArchived = _data["isArchived"];
        }
    }

    static fromJS(data: any): GeneralArchivableInput {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralArchivableInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["note"] = this.note;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        data["isArchived"] = this.isArchived;
        return data;
    }
}

export interface IGeneralArchivableInput {
    name: string | undefined;
    note: string | undefined;
    tags: TagDto[] | undefined;
    isArchived: boolean;
}

export class ListResultDtoOfUserOrOrganizationUnitDto implements IListResultDtoOfUserOrOrganizationUnitDto {
    items!: UserOrOrganizationUnitDto[] | undefined;

    constructor(data?: IListResultDtoOfUserOrOrganizationUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserOrOrganizationUnitDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfUserOrOrganizationUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfUserOrOrganizationUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfUserOrOrganizationUnitDto {
    items: UserOrOrganizationUnitDto[] | undefined;
}

export class MazarsPagedResultDtoOfEinspruchOverviewDto implements IMazarsPagedResultDtoOfEinspruchOverviewDto {
    items!: EinspruchOverviewDto[] | undefined;
    totalCount!: number;
    currentPage!: number | undefined;

    constructor(data?: IMazarsPagedResultDtoOfEinspruchOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(EinspruchOverviewDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.currentPage = _data["currentPage"];
        }
    }

    static fromJS(data: any): MazarsPagedResultDtoOfEinspruchOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new MazarsPagedResultDtoOfEinspruchOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["currentPage"] = this.currentPage;
        return data;
    }
}

export interface IMazarsPagedResultDtoOfEinspruchOverviewDto {
    items: EinspruchOverviewDto[] | undefined;
    totalCount: number;
    currentPage: number | undefined;
}

export class PagedResultDtoOfTaxOfficeProfileOverviewDto implements IPagedResultDtoOfTaxOfficeProfileOverviewDto {
    items!: TaxOfficeProfileOverviewDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfTaxOfficeProfileOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TaxOfficeProfileOverviewDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfTaxOfficeProfileOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfTaxOfficeProfileOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfTaxOfficeProfileOverviewDto {
    items: TaxOfficeProfileOverviewDto[] | undefined;
    totalCount: number;
}

export enum Priority {
    One = 1,
    Two = 2,
    Three = 3,
    Four = 4,
}

export class ProcessDto implements IProcessDto {
    stateType!: string | undefined;
    name!: string | undefined;

    constructor(data?: IProcessDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stateType = _data["stateType"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ProcessDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stateType"] = this.stateType;
        data["name"] = this.name;
        return data;
    }
}

export interface IProcessDto {
    stateType: string | undefined;
    name: string | undefined;
}

export class ProjectManagementInfoDto implements IProjectManagementInfoDto {
    assignedUser!: AssignableUserDto;
    criticality!: Criticality;
    priority!: Priority;
    effort!: number | undefined;

    constructor(data?: IProjectManagementInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assignedUser = _data["assignedUser"] ? AssignableUserDto.fromJS(_data["assignedUser"]) : <any>undefined;
            this.criticality = _data["criticality"];
            this.priority = _data["priority"];
            this.effort = _data["effort"];
        }
    }

    static fromJS(data: any): ProjectManagementInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectManagementInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assignedUser"] = this.assignedUser ? this.assignedUser.toJSON() : <any>undefined;
        data["criticality"] = this.criticality;
        data["priority"] = this.priority;
        data["effort"] = this.effort;
        return data;
    }
}

export interface IProjectManagementInfoDto {
    assignedUser: AssignableUserDto;
    criticality: Criticality;
    priority: Priority;
    effort: number | undefined;
}

export class Scope implements IScope {
    readonly name!: string | undefined;
    readonly value!: string | undefined;

    constructor(data?: IScope) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).name = _data["name"];
            (<any>this).value = _data["value"];
        }
    }

    static fromJS(data: any): Scope {
        data = typeof data === 'object' ? data : {};
        let result = new Scope();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface IScope {
    name: string | undefined;
    value: string | undefined;
}

export class SurveyLookupDto implements ISurveyLookupDto {
    id!: number;
    name!: string | undefined;

    constructor(data?: ISurveyLookupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): SurveyLookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyLookupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ISurveyLookupDto {
    id: number;
    name: string | undefined;
}

export class TagDto implements ITagDto {
    name!: string | undefined;

    constructor(data?: ITagDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): TagDto {
        data = typeof data === 'object' ? data : {};
        let result = new TagDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface ITagDto {
    name: string | undefined;
}

export class TaxAuthorityDto implements ITaxAuthorityDto {
    validFrom!: DateTime;
    validTo!: DateTime | undefined;
    publishDate!: DateTime;
    scope!: Scope;
    federalStateName!: string | undefined;
    taxAuthorityName!: string | undefined;
    taxAuthorityNumber!: string | undefined;

    constructor(data?: ITaxAuthorityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.validFrom = _data["validFrom"] ? DateTime.fromISO(_data["validFrom"].toString()) : <any>undefined;
            this.validTo = _data["validTo"] ? DateTime.fromISO(_data["validTo"].toString()) : <any>undefined;
            this.publishDate = _data["publishDate"] ? DateTime.fromISO(_data["publishDate"].toString()) : <any>undefined;
            this.scope = _data["scope"] ? Scope.fromJS(_data["scope"]) : <any>undefined;
            this.federalStateName = _data["federalStateName"];
            this.taxAuthorityName = _data["taxAuthorityName"];
            this.taxAuthorityNumber = _data["taxAuthorityNumber"];
        }
    }

    static fromJS(data: any): TaxAuthorityDto {
        data = typeof data === 'object' ? data : {};
        let result = new TaxAuthorityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["validFrom"] = this.validFrom ? this.validFrom.toString() : <any>undefined;
        data["validTo"] = this.validTo ? this.validTo.toString() : <any>undefined;
        data["publishDate"] = this.publishDate ? this.publishDate.toString() : <any>undefined;
        data["scope"] = this.scope ? this.scope.toJSON() : <any>undefined;
        data["federalStateName"] = this.federalStateName;
        data["taxAuthorityName"] = this.taxAuthorityName;
        data["taxAuthorityNumber"] = this.taxAuthorityNumber;
        return data;
    }
}

export interface ITaxAuthorityDto {
    validFrom: DateTime;
    validTo: DateTime | undefined;
    publishDate: DateTime;
    scope: Scope;
    federalStateName: string | undefined;
    taxAuthorityName: string | undefined;
    taxAuthorityNumber: string | undefined;
}

export class TaxOffice implements ITaxOffice {
    environment!: string | undefined;
    profileExpirationWarningTreshold!: number;
    profileExpirationTreshold!: number;

    constructor(data?: ITaxOffice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.environment = _data["environment"];
            this.profileExpirationWarningTreshold = _data["profileExpirationWarningTreshold"];
            this.profileExpirationTreshold = _data["profileExpirationTreshold"];
        }
    }

    static fromJS(data: any): TaxOffice {
        data = typeof data === 'object' ? data : {};
        let result = new TaxOffice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["environment"] = this.environment;
        data["profileExpirationWarningTreshold"] = this.profileExpirationWarningTreshold;
        data["profileExpirationTreshold"] = this.profileExpirationTreshold;
        return data;
    }
}

export interface ITaxOffice {
    environment: string | undefined;
    profileExpirationWarningTreshold: number;
    profileExpirationTreshold: number;
}

export class TaxOfficeConfiguration implements ITaxOfficeConfiguration {
    readonly name!: string | undefined;
    readonly value!: string | undefined;
    readonly orderIndex!: number;
    fullName!: string | undefined;
    activatedForModule!: string | undefined;
    description!: string | undefined;
    url!: string | undefined;
    receiverForCountries!: string | undefined;
    readonly countryCodes!: string[] | undefined;
    profileVariant!: string | undefined;

    constructor(data?: ITaxOfficeConfiguration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).name = _data["name"];
            (<any>this).value = _data["value"];
            (<any>this).orderIndex = _data["orderIndex"];
            this.fullName = _data["fullName"];
            this.activatedForModule = _data["activatedForModule"];
            this.description = _data["description"];
            this.url = _data["url"];
            this.receiverForCountries = _data["receiverForCountries"];
            if (Array.isArray(_data["countryCodes"])) {
                (<any>this).countryCodes = [] as any;
                for (let item of _data["countryCodes"])
                    (<any>this).countryCodes!.push(item);
            }
            this.profileVariant = _data["profileVariant"];
        }
    }

    static fromJS(data: any): TaxOfficeConfiguration {
        data = typeof data === 'object' ? data : {};
        let result = new TaxOfficeConfiguration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        data["orderIndex"] = this.orderIndex;
        data["fullName"] = this.fullName;
        data["activatedForModule"] = this.activatedForModule;
        data["description"] = this.description;
        data["url"] = this.url;
        data["receiverForCountries"] = this.receiverForCountries;
        if (Array.isArray(this.countryCodes)) {
            data["countryCodes"] = [];
            for (let item of this.countryCodes)
                data["countryCodes"].push(item);
        }
        data["profileVariant"] = this.profileVariant;
        return data;
    }
}

export interface ITaxOfficeConfiguration {
    name: string | undefined;
    value: string | undefined;
    orderIndex: number;
    fullName: string | undefined;
    activatedForModule: string | undefined;
    description: string | undefined;
    url: string | undefined;
    receiverForCountries: string | undefined;
    countryCodes: string[] | undefined;
    profileVariant: string | undefined;
}

export class TaxOfficeProfileDto implements ITaxOfficeProfileDto {
    id!: number;
    profileName!: string | undefined;
    taxOfficeName!: string | undefined;
    taxOfficeId!: string | undefined;
    countryCodes!: string[] | undefined;
    expirationDate!: DateTime;
    isExpirationWarningTresholdReached!: boolean;
    isExpirationTresholdReached!: boolean;
    credentialInfo!: CredentialInfoDto;

    constructor(data?: ITaxOfficeProfileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.profileName = _data["profileName"];
            this.taxOfficeName = _data["taxOfficeName"];
            this.taxOfficeId = _data["taxOfficeId"];
            if (Array.isArray(_data["countryCodes"])) {
                this.countryCodes = [] as any;
                for (let item of _data["countryCodes"])
                    this.countryCodes!.push(item);
            }
            this.expirationDate = _data["expirationDate"] ? DateTime.fromISO(_data["expirationDate"].toString()) : <any>undefined;
            this.isExpirationWarningTresholdReached = _data["isExpirationWarningTresholdReached"];
            this.isExpirationTresholdReached = _data["isExpirationTresholdReached"];
            this.credentialInfo = _data["credentialInfo"] ? CredentialInfoDto.fromJS(_data["credentialInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TaxOfficeProfileDto {
        data = typeof data === 'object' ? data : {};
        let result = new TaxOfficeProfileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["profileName"] = this.profileName;
        data["taxOfficeName"] = this.taxOfficeName;
        data["taxOfficeId"] = this.taxOfficeId;
        if (Array.isArray(this.countryCodes)) {
            data["countryCodes"] = [];
            for (let item of this.countryCodes)
                data["countryCodes"].push(item);
        }
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toString() : <any>undefined;
        data["isExpirationWarningTresholdReached"] = this.isExpirationWarningTresholdReached;
        data["isExpirationTresholdReached"] = this.isExpirationTresholdReached;
        data["credentialInfo"] = this.credentialInfo ? this.credentialInfo.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITaxOfficeProfileDto {
    id: number;
    profileName: string | undefined;
    taxOfficeName: string | undefined;
    taxOfficeId: string | undefined;
    countryCodes: string[] | undefined;
    expirationDate: DateTime;
    isExpirationWarningTresholdReached: boolean;
    isExpirationTresholdReached: boolean;
    credentialInfo: CredentialInfoDto;
}

export class TaxOfficeProfileOverviewDto implements ITaxOfficeProfileOverviewDto {
    id!: number;
    profileName!: string | undefined;
    taxOfficeName!: string | undefined;
    countryCodes!: string[] | undefined;
    expirationDate!: DateTime;
    isExpirationWarningTresholdReached!: boolean;
    isExpirationTresholdReached!: boolean;

    constructor(data?: ITaxOfficeProfileOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.profileName = _data["profileName"];
            this.taxOfficeName = _data["taxOfficeName"];
            if (Array.isArray(_data["countryCodes"])) {
                this.countryCodes = [] as any;
                for (let item of _data["countryCodes"])
                    this.countryCodes!.push(item);
            }
            this.expirationDate = _data["expirationDate"] ? DateTime.fromISO(_data["expirationDate"].toString()) : <any>undefined;
            this.isExpirationWarningTresholdReached = _data["isExpirationWarningTresholdReached"];
            this.isExpirationTresholdReached = _data["isExpirationTresholdReached"];
        }
    }

    static fromJS(data: any): TaxOfficeProfileOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new TaxOfficeProfileOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["profileName"] = this.profileName;
        data["taxOfficeName"] = this.taxOfficeName;
        if (Array.isArray(this.countryCodes)) {
            data["countryCodes"] = [];
            for (let item of this.countryCodes)
                data["countryCodes"].push(item);
        }
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toString() : <any>undefined;
        data["isExpirationWarningTresholdReached"] = this.isExpirationWarningTresholdReached;
        data["isExpirationTresholdReached"] = this.isExpirationTresholdReached;
        return data;
    }
}

export interface ITaxOfficeProfileOverviewDto {
    id: number;
    profileName: string | undefined;
    taxOfficeName: string | undefined;
    countryCodes: string[] | undefined;
    expirationDate: DateTime;
    isExpirationWarningTresholdReached: boolean;
    isExpirationTresholdReached: boolean;
}

export class UpdateEinspruchInput implements IUpdateEinspruchInput {
    general!: GeneralArchivableInput;
    specifics!: EinspruchSpecificInput;
    id!: number;

    constructor(data?: IUpdateEinspruchInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.general = _data["general"] ? GeneralArchivableInput.fromJS(_data["general"]) : <any>undefined;
            this.specifics = _data["specifics"] ? EinspruchSpecificInput.fromJS(_data["specifics"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateEinspruchInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEinspruchInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["general"] = this.general ? this.general.toJSON() : <any>undefined;
        data["specifics"] = this.specifics ? this.specifics.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateEinspruchInput {
    general: GeneralArchivableInput;
    specifics: EinspruchSpecificInput;
    id: number;
}

export class UpdateTaxOfficeProfileInput implements IUpdateTaxOfficeProfileInput {
    id!: number;
    profileName!: string | undefined;
    expirationDate!: DateTime;

    constructor(data?: IUpdateTaxOfficeProfileInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.profileName = _data["profileName"];
            this.expirationDate = _data["expirationDate"] ? DateTime.fromISO(_data["expirationDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateTaxOfficeProfileInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTaxOfficeProfileInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["profileName"] = this.profileName;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toString() : <any>undefined;
        return data;
    }
}

export interface IUpdateTaxOfficeProfileInput {
    id: number;
    profileName: string | undefined;
    expirationDate: DateTime;
}

export class UserOrOrganizationUnitDto implements IUserOrOrganizationUnitDto {
    type!: string | undefined;
    userOrOrganizationId!: number;
    displayName!: string | undefined;

    constructor(data?: IUserOrOrganizationUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.userOrOrganizationId = _data["userOrOrganizationId"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): UserOrOrganizationUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserOrOrganizationUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["userOrOrganizationId"] = this.userOrOrganizationId;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IUserOrOrganizationUnitDto {
    type: string | undefined;
    userOrOrganizationId: number;
    displayName: string | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}